/* eslint-disable react/prop-types */
import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { DefaultLayoutZIndex } from "./../../_utils/constraints";

function ErrorBox({ isError, error, isFullScreen = true, styleErrorBox = {} }) {
  if (!isError || !error) {
    return null; // Return early if there's no message
  }
  const errorMessage =
    typeof error === "string" && error.trim() !== ""
      ? error.trim()
      : typeof error === "object" && error !== null
      ? JSON.stringify(error)
      : `Error in type of message: ${typeof error}`;

  return (
    <Box
      style={{
        ...(isFullScreen && {
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          zIndex: DefaultLayoutZIndex + 5,
          padding: "0px 1rem",
          margin: "0px",
          width: "100%",
          minHeight: "100vh",
          opacity: 0.6,
          backgroundColor: "white",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }),
        ...styleErrorBox,
      }}
    >
      <ErrorOutlineIcon
        sx={{ color: "error.main" }}
        style={{ fontSize: "100px", marginBottom: "20px" }}
      />
      <Typography variant="inherit" color="error">
        {errorMessage}
      </Typography>
    </Box>
  );
}

export default ErrorBox;
